import React, {useEffect, useState} from 'react';
import {Modal, Result} from 'antd';

const App = ({
                 status,
                 title,
                 subTitle,
                 extra, openResult,setOpenResult
             }) => {

    const [open, setOpen] = useState(false);

    useEffect(() => {
        setOpen(openResult)
    }, [openResult]);
    const handleCancel = () => {
        setOpen(false);
        setOpenResult(false);
    };


    return <Modal
        open={open}
        // title=""
        onCancel={handleCancel}
        footer={null}
    ><Result
        status={status}
        title={title}
        subTitle={subTitle}
        extra={extra}
    /></Modal>
}

export default App;